// BEGHI GABRIEL
import ImgbgBeghiGabriel from '../components/Artistes/BeghiGabriel/gb1.JPG' ;
import ImgbgBeghiGabriel3 from '../components/Artistes/BeghiGabriel/gb3.JPG';
import ImgbgBeghiGabriel4 from '../components/Artistes/BeghiGabriel/gb4.JPG';
import ImgbgBeghiGabriel6 from '../components/Artistes/BeghiGabriel/gb6.JPG';
import imgPresBeghiGabriel from '../components/Artistes/BeghiGabriel/image001_2.jpg';

// EMMA HENRIOT
import ImgbgHenriot from  '../components/Artistes/EmmaHenriot/images/eh-2.jpg';
import ImgbgHenriot3 from  '../components/Artistes/EmmaHenriot/images/eh-3.jpg';
import ImgbgHenriot4 from  '../components/Artistes/EmmaHenriot/images/eh-4.jpg';
import ImgbgHenriot5 from  '../components/Artistes/EmmaHenriot/images/eh-5.jpg';
import ImgbgHenriotPres from  '../components/Artistes/EmmaHenriot/images/eh-pres.jpg';

// CHANTAL LALLEMAND
import ImgRdLallemandChantal from '../components/Artistes/LallemandChantal/images/cl1.jpg';
import ImgbgLallemandChantal from '../components/Artistes/LallemandChantal/images/cl2.jpg';
import ImgbgLallemandChantal3 from '../components/Artistes/LallemandChantal/images/cl3.jpg';
import ImgbgLallemandChantal4 from '../components/Artistes/LallemandChantal/images/cl4.jpg';
import ImgbgLallemandChantal5 from '../components/Artistes/LallemandChantal/images/cl5.jpg';
import ImgbgLallemandChantal6 from '../components/Artistes/LallemandChantal/images/cl6.jpg';

// RUSPOLI FRANCESCO
import imgRuspoli3 from '../components/Artistes/RuspoliFrancesco/images/rupoli-3.jpg';
import ImgRdRuspoli from '../components/Artistes/RuspoliFrancesco/images/rupoli-1.jpg';
import ImgBGRuspoli from '../components/Artistes/RuspoliFrancesco/images/rupoli-2.jpg';
import imgRuspoli5 from '../components/Artistes/RuspoliFrancesco/images/rupoli-5.jpg';
import ruspoliIMgBGRond from '../components/Artistes/RuspoliFrancesco/images/francescoImgBgRond.jpg';

// GERVAIS CECILE
import cg1 from '../components/Artistes/GervaisCecile/imagess/cg1.jpg';
import cg2 from '../components/Artistes/GervaisCecile/imagess/cg2.jpg';
import cg3 from '../components/Artistes/GervaisCecile/imagess/cg3.jpg';
import cgbground from '../components/Artistes/GervaisCecile/imagess/cgbground.jpg';
import cgrond from '../components/Artistes/GervaisCecile/imagess/cgrond.png';
import cgGV from '../assets/celineGervaisGV/CaptGervais.JPG';

// DANGLEANT PIERRE
import dprond from '../components/Artistes/DangelantPierre/IMG_3855.jpg';
import dpBGrond from '../components/Artistes/DangelantPierre/IMG_7559.jpg';
import dp1 from '../components/Artistes/DangelantPierre/IMG_7169.jpg';
import dp2 from '../components/Artistes/DangelantPierre/IMG_7667.jpg';
import dp3 from '../components/Artistes/DangelantPierre/IMG_9386.jpg';
import dp4 from '../components/Artistes/DangelantPierre/IMG_9474.jpg';

// DANIEL RENE
import reneRond from '../components/Artistes/ReneDaniel/reneRond.jpeg';
import reneBG from '../components/Artistes/ReneDaniel/essaimageCoralien.jpeg';
import rene1 from '../components/Artistes/ReneDaniel/ecorce.jpeg';
import rene2 from '../components/Artistes/ReneDaniel/spiral.jpeg';
import rene3 from '../components/Artistes/ReneDaniel/blueMoon.jpeg';
import rene4 from '../components/Artistes/ReneDaniel/essaimageCoralien.jpeg';
import reneGV from '../assets/reneDaniel/CaptureReneDaniel.JPG';

// GARAPON SOPHIE
import GpRond from '../components/Artistes/GaraponSophie/images/GaraponRond.jpg';
import GsHeader from '../components/Artistes/GaraponSophie/images/23.jpg';
import Gs1 from '../components/Artistes/GaraponSophie/images/9.jpg';
import Gs2 from '../components/Artistes/GaraponSophie/images/15.jpg';
import Gs3 from '../components/Artistes/GaraponSophie/images/16.jpg';
import Gs4 from '../components/Artistes/GaraponSophie/images/26.jpg';

// DEBRIVA ANTOINE
import ADrond from '../assets/tete.jpeg' ;
import ADHeader from '../components/Artistes/DebrivaAntoine/images/DAHeader.jpg';
import AD1 from '../assets/qsdfqsdf.jpg';
import AD2 from '../assets/qsdfAD.jpg';
import AD3 from '../assets/qsdf.jpeg';

// DOE
import doeHeader from '../assets/DOE/Header_1222.jpg';
import doeRond from '../assets/DOE/IMG_70308DH_rond.jpg';
import doe1 from '../assets/DOE/image2_DH2.jpg';
import doe2 from '../assets/DOE/IMG_2114_OK_DH1.jpg';
import doe3 from '../assets/DOE/IMG_6128_DH3.jpg';

// LAUNAY DANNIE
import launay1 from '../assets/launay/launay1Portrait.JPG'
import launay2 from '../assets/launay/launay2Portrait.JPG'
import launay3 from '../assets/launay/launay3Paysage.JPG'
import launayHeader4 from '../assets/launay/launay4PaysageLarge.JPG'
import launay5 from '../assets/launay/launay5Paysage.JPG'
import launayVisage from '../assets/launay/launayVisage.JPG'

export default [
    {
        id: 0,
        NameArtist : "Beghi Gabriel",
        NameURL : "BeghiGabriel",
        CategorieArtiste: 'General.spe', 
        link: '/Beghi-Gabriel', 
        imgProfilRond: imgPresBeghiGabriel,
        imgbg:   ImgbgBeghiGabriel,
        imgSuite1 : ImgbgBeghiGabriel3,
        imgSuite2 : ImgbgBeghiGabriel4,
        imgSuite3 : ImgbgBeghiGabriel,
        imgSuite4 : ImgbgBeghiGabriel6,
        txt : "Artistes.BeghiGabriel.txt",
        fb : "",
        insta : "https://www.instagram.com/gabrielbeghi/",
        SitePerso: "", 
        tableaux : {
            g1 : "Artistes.BeghiGabriel.Tableaux.1G",
            m1 : "Artistes.BeghiGabriel.Tableaux.1M",
            d1 : "Artistes.BeghiGabriel.Tableaux.1D",
        },
        linkToUnity: '', 
        galerieVirtuel : false, 
        PourTranslate : 'ok',
        isMultiCarr : false,
        imgMulticarr : ImgbgBeghiGabriel,  
        isCardRond: true,
        imgCardRond : imgPresBeghiGabriel,
    },
    {
        id: 1,
        NameArtist : "Henriot Emma",
        NameURL : "HenriotEmma",
        CategorieArtiste: 'General.spe', 
        link: "/Henriot-Emma",
        imgProfilRond: ImgbgHenriotPres,
        imgbg:   ImgbgHenriot,
        imgSuite1 : ImgbgHenriot3,
        imgSuite2 : ImgbgHenriot4,
        imgSuite3 : ImgbgHenriot5,
        imgSuite4 : ImgbgBeghiGabriel6,
        txt : "Artistes.HenriotEmma.txt",
        fb : "",
        insta : "",
        SitePerso: "https://www.emma-henriot.com", 
        tableaux : {
            g1 : "Artistes.HenriotEmma.Tableaux.1G",
            m1 : "Artistes.HenriotEmma.Tableaux.1M",
            d1 : "Artistes.HenriotEmma.Tableaux.1D",
        },
        linkToUnity: '', 
        galerieVirtuel : false, 
        isMultiCarr : false,
        imgMulticarr : ImgbgHenriot,
        isCardRond: true,
        imgCardRond : ImgbgHenriotPres,
    },
    {
        id: 3,
        NameArtist : "Lallemand Chantal",
        NameURL : "LallemandChantal",
        CategorieArtiste: 'General.spe', 
        link: "/Lallemand-Chantal",
        imgProfilRond: ImgRdLallemandChantal,
        imgbg:   ImgbgLallemandChantal,
        imgSuite1 : ImgbgLallemandChantal3,
        imgSuite2 : ImgbgLallemandChantal4,
        imgSuite3 : ImgbgLallemandChantal5,
        imgSuite4 : ImgbgLallemandChantal6,
        txt : "Artistes.LallemandChantal.txt",
        fb : "",
        insta : "",
        SitePerso: "https://echoes-nch.com/", 
        tableaux : {
            g1 : "Artistes.LallemandChantal.Tableaux.1G",
            m1 : "Artistes.LallemandChantal.Tableaux.1M",
            d1 : "Artistes.LallemandChantal.Tableaux.1D",
        },
        linkToUnity: '' , 
        galerieVirtuel : false, 
        isMultiCarr : false,
        imgMulticarr : ImgbgLallemandChantal6,
        isCardRond: true,
        imgCardRond : ImgRdLallemandChantal,
    },
    {
        id: 4,
        NameArtist : "Ruspoli Francesco",
        NameURL : "RuspoliFrancesco",
        CategorieArtiste: 'General.spe', 
        link: "/Ruspoli-Francesco", 
        imgProfilRond: ruspoliIMgBGRond ,
        imgbg:   ImgBGRuspoli,
        imgSuite1 : ImgRdRuspoli,
        imgSuite2 : imgRuspoli3,
        imgSuite3 : imgRuspoli5,
        imgSuite4 : imgRuspoli5,
        txt : "Artistes.FrancescoRuspoli.txt",
        fb : "",
        insta : "",
        SitePerso: "https://francescoruspoliart.com/", 
        tableaux : {
            g1 : "Artistes.FrancescoRuspoli.Tableaux.1G",
            m1 : "Artistes.FrancescoRuspoli.Tableaux.1M",
            d1 : "Artistes.FrancescoRuspoli.Tableaux.1D",
        },
        linkToUnity: '', 
        galerieVirtuel : false, 
        isMultiCarr : true,
        imgMulticarr : imgRuspoli5,
        isCardRond: true,
        imgCardRond : ruspoliIMgBGRond,
    },
    {
        id: 5,
        NameArtist : "Gervais Cecile",
        NameURL : "GervaisCecile",
        CategorieArtiste: 'General.spe', 
        link: "/GervaisCecile", 
        imgProfilRond:  cgrond,
        imgbg:  cgbground ,
        imgSuite1 : cg1,
        imgSuite2 : cg2,
        imgSuite3 : cg3,
        imgSuite4 : cg3,
        txt : "Artistes.GervaisCecile.txt",
        fb : "",
        insta : "",
        SitePerso: "https://www.studiodelarte.com", 
        tableaux : {
            g1 : "Artistes.GervaisCecile.Tableaux.1G",
            m1 : "Artistes.GervaisCecile.Tableaux.1M",
            d1 : "Artistes.GervaisCecile.Tableaux.1D",
        },
        linkToUnity: 'https://gervais-cecile.artandgalleries.com/', 
        galerieVirtuel : true, 
        photoGV : cgGV,
        isMultiCarr : true,
        imgMulticarr : cg3,
        isCardRond: true,
        imgCardRond : cgrond,
    },
    {
        id: 6,
        NameArtist : "Dangleant Pierre",
        NameURL : "DangleantPierre",
        CategorieArtiste: 'General.spe', 
        link: "/DangelantPierre", 
        imgProfilRond: dprond ,
        imgbg:   dpBGrond,
        imgSuite1 : dp1,
        imgSuite2 : dp2,
        imgSuite3 : dp3,
        imgSuite4 : dp4,
        txt : "Artistes.DangelantPierre.txt",
        fb : "",
        insta : "",
        SitePerso: "https://www.artistepeintrepdangleant.com/", 
        tableaux : {
            g1 : "Artistes.DangelantPierre.Tableaux.1G",
            m1 : "Artistes.DangelantPierre.Tableaux.1M",
            d1 : "Artistes.DangelantPierre.Tableaux.1D",
        },
        linkToUnity: '', 
        galerieVirtuel : false, 
        isMultiCarr : true,
        imgMulticarr : dp3,
        isCardRond: true,
        imgCardRond : dprond ,
    }, 
    {
        id: 7,
        NameArtist : "Rene Daniel",
        NameURL : "ReneDaniel",
        CategorieArtiste: 'General.spe', 
        link: "/ReneDaniel", 
        imgProfilRond: reneRond ,
        imgbg:   reneBG,
        imgSuite1 : rene1,
        imgSuite2 : rene2,
        imgSuite3 : rene3,
        imgSuite4 : rene4,
        txt : "Artistes.ReneDaniel.txt",
        fb : "https://www.facebook.com/danielrene.bois.de.bout",
        insta : "",
        SitePerso: "https://1555290.site123.me/", 
        tableaux : {
            g1 : "Artistes.ReneDaniel.Tableaux.1G",
            m1 : "Artistes.ReneDaniel.Tableaux.1M",
            d1 : "Artistes.ReneDaniel.Tableaux.1D",
        },
        linkToUnity: 'https://daniel-rene.artandgalleries.com/', 
        galerieVirtuel : true, 
        photoGV : reneGV ,
        isMultiCarr : true,
        imgMulticarr : rene4,
        isCardRond: true,
        imgCardRond : reneRond ,
        
    },
    {
        id: 8,
        NameArtist : "Garapon Sophie",
        NameURL : "GaraponSophie",
        CategorieArtiste: 'General.spe', 
        link: "/GaraponSophie", 
        imgProfilRond: GpRond,
        imgbg:   GsHeader,
        imgSuite1 : Gs1,
        imgSuite2 : Gs2,
        imgSuite3 : Gs3,
        imgSuite4 : Gs4,
        txt : "Artistes.GaraponSophie.txt",
        fb : "",
        insta : "https://www.instagram.com/sophie.garapon/",
        SitePerso: "https://www.hamadryades.fr", 
        tableaux : {
            g1 : "Artistes.GaraponSophie.Tableaux.1G",
            m1 : "Artistes.GaraponSophie.Tableaux.1M",
            d1 : "Artistes.GaraponSophie.Tableaux.1D",
        },
        linkToUnity: '' , 
        galerieVirtuel : false, 
        isMultiCarr : true,
        imgMulticarr : Gs2,
        isCardRond: true,
        imgCardRond : GpRond ,
    },
    {
        id: 9,
        NameArtist : "Debriva Antoine",
        NameURL : "DebrivaAntoine",
        CategorieArtiste: 'General.spe', 
        link: "/DebrivaAntoine", 
        imgProfilRond: ADrond,
        imgbg:   ADHeader,
        imgSuite1 : AD1,
        imgSuite2 : AD2,
        imgSuite3 : AD3,
        imgSuite4 : AD3,
        txt : "Artistes.DebrivaAntoine.txt",
        fb : "",
        insta : "",
        SitePerso: "https://antoinedebriva.com/", 
        tableaux : {
            g1 : "Artistes.DebrivaAntoine.Tableaux.1G",
            m1 : "Artistes.DebrivaAntoine.Tableaux.1M",
            d1 : "Artistes.DebrivaAntoine.Tableaux.1D",
        },
        linkToUnity: '' , 
        galerieVirtuel : false, 
        isMultiCarr : true,
        imgMulticarr : AD3,
        isCardRond: true,
        imgCardRond : ADrond ,
    },
    {
        id: 10,
        NameArtist : "Dohe",
        NameURL : "Dohe",
        CategorieArtiste: 'General.spe', 
        link: "/HeitzDominique", 
        imgProfilRond: doeRond,
        imgbg:   doeHeader,
        imgSuite1 : doe1,
        imgSuite2 : doe2,
        imgSuite3 : doe3,
        imgSuite4 : doeHeader,
        txt : "Artistes.HeitzDominique.txt",
        fb : "https://www.facebook.com/Dohe-Dominique-heitz-229412410940151",
        insta : "https://www.instagram.com/heitzdominique/",
        SitePerso: "http://dohe67.canalblog.com/", 
        tableaux : {
            g1 : "Artistes.HeitzDominique.Tableaux.1G",
            m1 : "Artistes.HeitzDominique.Tableaux.1M",
            d1 : "Artistes.HeitzDominique.Tableaux.1D",
        },
        linkToUnity: '' , 
        galerieVirtuel : false, 
        isMultiCarr : true,
        imgMulticarr : doe2,
        isCardRond: true,
        imgCardRond : doeRond ,
    },
    {
        id: 11,
        NameArtist : "Launay Dannie ",
        NameURL : "LaunayDannie",
        CategorieArtiste: 'General.spe', 
        link: "/LaunayDannie", 
        imgProfilRond: launayVisage,
        imgbg:   launayHeader4,
        imgSuite1 : launay1,
        imgSuite2 : launay2,
        imgSuite3 : launay3,
        imgSuite4 : launay5,
        txt : "DannieLaunay.txt",
        fb : "",
        insta : "",
        SitePerso: "https://www.dannielaunay-artbrut.racv.fr/", 
        tableaux : {
            g1 : "",
            m1 : "",
            d1 : "",
        },
        linkToUnity: '' , 
        galerieVirtuel : false, 
        isMultiCarr : true,
        imgMulticarr : launay2,
        isCardRond: true,
        imgCardRond : launayVisage ,
    }
]


// {
//     id: 2,
//     NameArtist : "Groover Dan",
//     CategorieArtiste: 'General.spe', 
//     link: "/Dan-Groover",
//     imgProfilRond: ImgRdGrooverDan,
//     imgbg:   ImgbgGrooverDan,
//     imgSuite1 : Groover3,
//     imgSuite2 : Groover4,
//     imgSuite3 : Groover5,
//     imgSuite4 : Groover6,
//     txt : "Artistes.GrooverDan.txt",
//     fb : "https://www.facebook.com/dan.grooverarts",
//     insta : "https://www.instagram.com/dangrooverarts/",
//     SitePerso: "https://www.israelmodernart.com/artists/dan-groover", 
//     tableaux : {
//         g1 : "Artistes.GrooverDan.Tableaux.1G",
//         m1 : "Artistes.GrooverDan.Tableaux.1M",
//         d1 : "Artistes.GrooverDan.Tableaux.1D",
//     },
//     linkToUnity: '', 
//     galerieVirtuel : false, 
//     isMultiCarr : true,
//     imgMulticarr : Groover3,
//     isCardRond: true,
//     imgCardRond : ImgRdGrooverDan,

// },

// LAVOREL OLIVIER
// import ImgRondLavorelOLivier from '../assets/olPortrait.jpg'
// import ImgBgLavorelOlivier from '../components/Artistes/LavorelOlivier/images/3-4.jpg'
// import imgLavorel1 from '../components/Artistes/LavorelOlivier/images/1-4.jpg'
// import imgLavorel2 from '../components/Artistes/LavorelOlivier/images/2-4.jpg'
// import imgLavorel3 from '../components/Artistes/LavorelOlivier/images/3-4.jpg'
// import imgLavorel4 from '../components/Artistes/LavorelOlivier/images/img024.jpg'

// SKOROCHOD NATACHA
// import ImgRdSkorochod from '../components/Artistes/natachaSKOROCHOD/images/skorochod-pres.jpg'
// import ImgBgSkorochod from '../components/Artistes/natachaSKOROCHOD/images/skorochod-4.jpg'
// import ImgBgSkorochod1 from '../components/Artistes/natachaSKOROCHOD/images/skorochod-1.jpg'
// import ImgBgSkorochod2 from '../components/Artistes/natachaSKOROCHOD/images/skorochod-2.jpg'
// import ImgBgSkorochod3 from '../components/Artistes/natachaSKOROCHOD/images/skorochod-3.jpg'


// GROOVER DAN
// import ImgRdGrooverDan from '../components/Artistes/GrooverDan/images/portraitGroover.jfif';
// import ImgbgGrooverDan from '../components/Artistes/GrooverDan/images/img_6569.jpg';
// import Groover3 from '../components/Artistes/GrooverDan/images/1bdd087d0e41eb753cca1ae6cf2f619a.jpg';
// import Groover4 from '../components/Artistes/GrooverDan/images/img_6568.jpg';
// import Groover5 from '../components/Artistes/GrooverDan/images/img_7701.jpg';
// import Groover6 from '../components/Artistes/GrooverDan/images/metro-groover.jpg';